module.exports = __webpack_public_path__ + "media/images/pic/workshops/sorki-nie-czaje-35b6a6525b1f631719a354d100de01ca.jpeg";